// // BasicDatePicker.js
// import React from "react";
// import { Field } from "formik";
// import { KeyboardDatePicker } from "@material-ui/pickers";

// const BasicDatePicker = ({ name, label, ...props }) => {
// 	return (
// 		<Field name={name}>
// 			{({ field, form }) => (
// 				<KeyboardDatePicker
// 					{...field}
// 					{...props}
// 					label={label}
// 					format='MM/dd/yyyy'
// 					error={form.errors[name] && form.touched[name]}
// 					helperText={
// 						form.touched[name] && form.errors[name]
// 					}
// 				/>
// 			)}
// 		</Field>
// 	);
// };

// export default BasicDatePicker;

import React from "react";
import { TextField } from "@material-ui/core";
import { useField } from "formik";

function BasicDatePicker({ name, ...otherProps }) {
	const [field, meta] = useField(name);

	const configDateTimePicker = {
		...field,
		...otherProps,
		type: "date",
		variant: "outlined",
		fullWidth: true,
		InputLabelProps: {
			shrink: true,
		},
	};

	if (meta && meta.touched && meta.error) {
		configDateTimePicker.error = true;
		configDateTimePicker.helperText = meta.error;
	}

	return (
		<div>
			<TextField
				{...configDateTimePicker}
			/>
		</div>
	);
}

export default BasicDatePicker;
